import styled, { css } from 'styled-components';
import { ellipsisStyle, flexCenter, visuallyHidden } from '../../styled/mixins';
import { Col, Row } from '../../styled';
import { contentWidthMedia } from '../../styled/utils';
import { contentBreakpoints } from 'constants/breakpoints';

export const ViewEventListItemBox = styled(Row)`
    width: 100%;
    box-sizing: border-box;
    padding: ${({ $isMobile }) => ($isMobile ? '8px' : '12px 16px 12px 0')};
    flex-wrap: ${({ $isMobile }) => ($isMobile ? 'wrap' : 'nowrap')};
    gap: ${({ $isMobile }) => ($isMobile ? '4px 0' : '8px')};
    font-size: 13px;
`;

export const ViewEventListVinderspilBox = styled(ViewEventListItemBox)`
    flex-direction: column;
    gap: 16px;
    padding: 12px 16px;
`;

export const EventColMeta = styled.div`
    max-width: 325px;
    min-width: 160px;
    padding-inline: ${({ $isMobile }) => ($isMobile ? '0 8px' : '16px 0')};
    flex: ${({ $isMobile }) => ($isMobile ? '0 1 auto' : '1 1 auto')};
    display: flex;
    align-items: center;
    gap: 8px;
    box-sizing: border-box;
    color: ${({ theme }) => theme.text.neutralBlack};
    order: ${({ $isMobile }) => ($isMobile ? '2' : '0')};
    width: ${({ $isMobile }) => ($isMobile ? '52%' : '30%')};

    ${({ $contentWidth, $isMobile }) => {
        const media = contentWidthMedia($contentWidth);

        return (
            !$isMobile &&
            css`
                ${media.lessThan(
                    contentBreakpoints.LG,
                    css`
                        max-width: 315px;
                    `
                )};

                ${media.lessThan(
                    contentBreakpoints.MD,
                    css`
                        width: 27%;
                        max-width: 280px;
                    `
                )};

                ${media.lessThan(
                    670,
                    css`
                        width: 25%;
                        max-width: 220px;
                        min-width: 175px;
                    `
                )};

                ${media.lessThan(
                    contentBreakpoints.SM,
                    css`
                        width: 34%;
                        max-width: 289px;
                        flex: 0 1 auto;
                    `
                )};
                ${media.lessThan(
                    contentBreakpoints.XS,
                    css`
                        width: 38%;
                        max-width: 200px;
                    `
                )};
            `
        );
    }};
`;

export const EventNames = styled.div`
    display: flex;
    flex-direction: column;
    cursor: pointer;
    flex: 1 1 0;
    padding-block: ${({ $isMobile }) => ($isMobile ? '6px' : '0')};
    overflow: hidden;
`;

export const EventName = styled.div`
    display: flex;
    font-weight: 700;
    line-height: 20px;
    ${ellipsisStyle};
`;

export const EventNamesVinderspil = styled.div`
    display: flex;
`;

export const EventNameVinderspil = styled(EventName)`
    width: auto;
    max-width: none;
    color: #545454;
`;

export const EventNameExtraInfo = styled.div`
    position: relative;
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
`;

export const ActivePlayerName = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    line-height: 20px;

    img {
        margin-left: 2px;
    }
`;

export const LiveScoreTime = styled.div`
    width: ${({ $isMobile }) => ($isMobile ? '36px' : '32px')};
    line-height: ${({ $isMobile }) => ($isMobile ? '20px' : '40px')};
    margin-right: ${({ $isMobile }) => ($isMobile ? 'auto' : '0')};
    box-sizing: border-box;
    border-radius: 4px;
    background: ${({ theme }) => theme.bg.semanticErrorBackgroundLight};
    color: ${({ theme }) => theme.text.liveRedDark};
    font-size: 10px;
    font-weight: 400;
    text-align: center;
    flex-shrink: 0;
`;

export const EventScoreBySets = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 6px;
`;

export const EventScoreCol = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: center;
    font-weight: 700;
    line-height: 20px;
    padding: 0 8px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid ${({ theme }) => theme.borders.neutralBorder};
    background: ${({ theme }) => theme.bg.neutralGrey};

    ${({ $withoutBg }) =>
        $withoutBg &&
        css`
            font-weight: 400;
            border-color: transparent;
            background: transparent;
            padding: 0;
            width: 14px;
        `};
`;

export const EventTimeCol = styled.div`
    display: flex;
    flex-direction: ${({ $isMobile }) => ($isMobile ? 'row' : 'column')};
    gap: ${({ $isMobile }) => ($isMobile ? '2px' : '0')};
    margin-right: ${({ $isMobile }) => ($isMobile ? 'auto' : '0')};
    width: ${({ $isMobile }) => ($isMobile ? 'auto' : '32px')};
    flex-shrink: 0;
    font-size: ${({ $isMobile }) => ($isMobile ? '10px' : '13px')};
    line-height: ${({ $isMobile }) => ($isMobile ? '16px' : '20px')};
`;

export const EventTime = styled.div`
    white-space: nowrap;
    text-transform: ${({ $capitalize }) =>
        $capitalize ? 'capitalize' : 'none'};
`;

export const EventMainMarkets = styled.div`
    flex: 1;
    width: ${({ $isMobile }) => ($isMobile ? '48%' : '50%')};
    order: ${({ $isMobile }) => ($isMobile ? '3' : '0')};

    ${({ $contentWidth, $isMobile }) => {
        const media = contentWidthMedia($contentWidth);

        return (
            !$isMobile &&
            css`
                ${media.lessThan(
                    contentBreakpoints.LG,
                    css`
                        width: 52%;
                        max-width: 500px;
                        flex: 1 0 auto;
                    `
                )};

                ${media.lessThan(
                    contentBreakpoints.MD,
                    css`
                        width: 54%;
                    `
                )};

                ${media.lessThan(
                    660,
                    css`
                        width: 44%;
                        max-width: 380px;
                    `
                )};

                ${media.lessThan(
                    contentBreakpoints.SM,
                    css`
                        width: 50%;
                        max-width: 296px;
                    `
                )};

                ${media.lessThan(
                    contentBreakpoints.XS,
                    css`
                        width: 43%;
                        max-width: 206px;
                    `
                )};
            `
        );
    }};
`;

export const EventVinderspilMarketItem = styled(Col)`
    width: ${({ $isMobile }) =>
        $isMobile ? '100%' : 'calc((100% - 8px) / 2)'};
    flex-grow: 1;
    box-sizing: border-box;
`;

export const EventColRight = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    flex-grow: 0;
    width: ${({ $isMobile }) => ($isMobile ? '100%' : '86px')};
    gap: ${({ $isMobile }) => ($isMobile ? '4px' : '8px')};

    i {
        font-size: 18px;
        color: #186bf5;
    }
`;

export const LinkShowAllMarkets = styled.div`
    cursor: pointer;
    flex-shrink: 0;
    text-align: center;
    width: ${({ $isMobile }) => ($isMobile ? '39px' : '40px')};
    line-height: ${({ $isMobile }) => ($isMobile ? '18px' : '38px')};
    order: ${({ $isMobile }) => ($isMobile ? '2' : '0')};
    font-size: 10px;
    font-weight: 400;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.borders.neutralBorder};
    background: ${({ theme }) => theme.bg.neutralGrey};

    ${({ $visible, $isMobile }) => {
        if (!$visible && !$isMobile) {
            return visuallyHidden;
        } else if (!$visible) {
            return 'display: none;';
        } else {
            return '';
        }
    }};
`;

export const LiveSreamIcon = styled.div`
    flex-shrink: 0;
    ${flexCenter};
    width: ${({ $isMobile }) => ($isMobile ? '26px' : '38px')};
    height: ${({ $isMobile }) => ($isMobile ? '20px' : '42px')};
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.borders.neutralBorder};
    background: ${({ theme }) => theme.bg.neutralGrey};
    ${({ $visible }) => !$visible && visuallyHidden};
    display: ${({ $visible, $isMobile }) =>
        !$visible && $isMobile ? 'none' : 'flex'};

    img {
        object-fit: contain;
    }
`;

export const SmallInfoTextVinderspil = styled.div`
    line-height: 20px;
    color: #555;
    font-size: 12px;
`;
